var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shadow card",style:([
    _vm.bg && {
      backgroundColor: _vm.theme.color[_vm.bg] ? _vm.theme.color[_vm.bg] : _vm.bg,
    } ])},[(!!_vm.$slots['card-header'])?_c('div',{staticClass:"card-header"},[_vm._t("card-header")],2):_vm._e(),(!!_vm.$slots['card-body'])?_c('div',{staticClass:"card-body"},[_vm._t("card-body")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }